// libraries.
import { useState } from "react";

// store.
import { useUserProfile } from "@shared/GoogleLoginButton/user-slice/useUserProfile.hook";
import { useGetSubRutasQuery } from "@store/apiSlices/incentiveRules/subRutas.endpoints";

// styles.
import { StyledRulesContainer } from "./styles";

// components.
import { RulesTabs } from "./components/RulesTabs";
import { CreateRuleModal } from "./components/CreateRuleModal";

export const RulesMain = () => {
  const { country } = useUserProfile();
  const resolvedCountry = country || "CO";
  const schema = resolvedCountry === "MX" ? "inventory_mx" : "inventory_co";

  const { data: subRutas = [] } = useGetSubRutasQuery({ schema });
  const defaultSubRutaId = subRutas[0]?.id ?? 0;

  const [showCreate, setShowCreate] = useState(false);

  return (
    <StyledRulesContainer>
      <div className="rules-fixed-header">
        <div className="d-flex align-items-center justify-content-between">
          <h1 className="rules-title">B-Rules</h1>
          <button
            className="rules-new-btn"
            onClick={() => setShowCreate(true)}
          >
            ＋ Nueva regla
          </button>
        </div>
      </div>

      <RulesTabs />

      <CreateRuleModal
        show={showCreate}
        country={resolvedCountry}
        subRutaId={defaultSubRutaId}
        stateRoute={1}
        onClose={() => setShowCreate(false)}
      />
    </StyledRulesContainer>
  );
};
